import { render, staticRenderFns } from "./switch-control.vue?vue&type=template&id=3d8b6aa5"
import script from "./switch-control.vue?vue&type=script&lang=js"
export * from "./switch-control.vue?vue&type=script&lang=js"
import style0 from "./switch-control.vue?vue&type=style&index=0&id=3d8b6aa5&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports